export default {
  routes: [{
    path: "/",
    name: "Login",
    meta: {
      auth: true,
    },
    component: () => import("@/view/LoginPage"),
  },
  {
    path: "/Header",
    name: "Header",
    component: () => import("@/view/Header"),
    children: [
      // 账号管理
      {
        path: "/system/admin",
        name: "Admin",
        component: () => import("@/view/system/Admin"),
      },
      {
        path: "/system/fankui",
        name: "Fankui",
        component: () => import("@/view/system/Fankui"),
      },
      {
        path: "/system/dashboard",
        name: "Dashboard",
        component: () => import("@/view/system/Dashboard"),
      },
      {
        path: "/system/dashboard_1",
        name: "Dashboard_1",
        component: () => import("@/view/system/Dashboard_1"),
      },
      {
        path: "/system/dashboard_2",
        name: "Dashboard_2",
        component: () => import("@/view/system/Dashboard_2"),
      },
      /* 小程序设置 */
      {
        path: "/config/vipUser",
        name: "ConfigVipUser",
        component: () => import("@/view/config/VipUser"),
      },
      {
        path: "/config/banner",
        name: "ConfigBanner",
        component: () => import("@/view/config/Banner"),
      },
      {
        path: "/config/answer",
        name: "ConfigAnswer",
        component: () => import("@/view/config/answer"),
      },
      {
        path: "/config/pageConfig",
        name: "PageConfig",
        component: () => import("@/view/config/PageConfig"),
      },

      // 问答模块
      {
        path: "/answers/goodkinds",
        name: "AnswersGoodkinds",
        component: () => import("@/view/answers/Goodkinds.vue"),
      },
      {
        path: "/answers/userArchives",
        name: "AnswersUserArchives",
        component: () => import("@/view/answers/userArchives.vue"),
      },
      {
        path: "/answers/chatList",
        name: "AnswersChatList",
        component: () => import("@/view/answers/ChatList.vue"),
      },
      {
        path: "/answers/chatList_all",
        name: "AnswersChatList",
        component: () => import("@/view/answers/ChatList_all.vue"),
      },
      {
        path: "/answers/danger",
        name: "AnswersDanger",
        component: () => import("@/view/answers/danger.vue"),
      },
      {
        path: "/answers/operation",
        name: "AnswersOperation",
        component: () => import("@/view/answers/operation.vue"),
      },
      {
        path: "/answers/lack",
        name: "AnswersLack",
        component: () => import("@/view/answers/lack.vue"),
      },
      // 预约服务
      {
        path: "/appointment/nurse",
        name: "AppointmentNurse",
        component: () => import("@/view/appointment/nurse.vue"),
      },
      {
        path: "/appointment/address",
        name: "AppointmentAddress",
        component: () => import("@/view/appointment/address.vue"),
      },
      {
        path: "/appointment/nurseOrder",
        name: "AppointmentNurseOrder",
        component: () => import("@/view/appointment/nurseOrder"),
      },
      // 商城模块
      {
        path: "/mall/goodkinds",
        name: "MallGoodkinds",
        component: () => import("@/view/mall/Goodkinds.vue"),
      },
      {
        path: "/mall/goods",
        name: "MallGoods",
        component: () => import("@/view/mall/Goods"),
      },
      {
        path: "/mall/order",
        name: "MallOrder",
        component: () => import("@/view/mall/Order"),
      },

      /* 体检模块 */
      {
        path: "/niaojian/goodkinds",
        name: "NiaojianGoodkinds",
        component: () => import("@/view/niaojian/Goodkinds"),
      },
      //检测机器
      {
        path: "/niaojian/robotOrder",
        name: "NiaojianRobotOrder",
        component: () => import("@/view/niaojian/RobotOrder.vue"),
      },
      //检测机构订单
      {
        path: "/niaojian/OrganizationOrder",
        name: "NiaojianOrganizationOrder",
        component: () => import("@/view/niaojian/OrganizationOrder.vue"),
      },
      //人工录入检测数据
      {
        path: "/niaojian/handResult",
        name: "NiaojianHandResult",
        component: () => import("@/view/niaojian/handResult/index.vue"),
      },
      //贴吧
      {
        path: "/tieba/list",
        name: "TiebaList",
        component: () => import("@/view/tieba/list/index.vue"),
      },
      //评论列表
      {
        path: "/tieba/comment",
        name: "TiebaComment",
        component: () => import("@/view/tieba/comment/index.vue"),
      },

      //投票活动参与者列表
      {
        path: "/vote/type",
        name: "VoteType",
        component: () => import("@/view/vote/type/index.vue"),
      },
      {
        path: "/vote/commit",
        name: "VoteCommit",
        component: () => import("@/view/vote/commit/index.vue"),
      },
      {
        path: "/vote/list",
        name: "VoteList",
        component: () => import("@/view/vote/list/index.vue"),
      },
      {
        path: "/vote/record",
        name: "VoteRecord",
        component: () => import("@/view/vote/record/index.vue"),
      },

      /* 视频模块 */
      //视频列表
      {
        path: "/video/list",
        name: "VideoList",
        component: () => import("@/view/video/list"),
      },
      //评论列表
      {
        path: "/video/comment",
        name: "VideoComment",
        component: () => import("@/view/video/comment/index.vue"),
      },
      //点赞记录
      {
        path: "/video/likeRecord",
        name: "VideoLikeRecord",
        component: () => import("@/view/video/likeRecord/index.vue"),
      },

      /* 营销模块 */
      {
        path: "/marketing/moneyRecord",
        name: "MarketingMoneyRecord",
        component: () => import("@/view/marketing/MoneyRecord.vue"),
      },
      {
        path: "/marketing/vipUser",
        name: "MarketingVipUser",
        component: () => import("@/view/marketing/VipUser"),
      },
      {
        path: "/marketing/vipConfig",
        name: "MarketingVipConfig",
        component: () => import("@/view/marketing/VipConfig.vue"),
      },
      {
        path: "/marketing/couponList",
        name: "MarketingCouponList",
        component: () => import("@/view/marketing/CouponList"),
      },
      {
        path: "/marketing/bonus",
        name: "Marketingbonus",
        component: () => import("@/view/marketing/bonus"),
      },
      {
        path: "/couponCard/create",
        name: "CouponCard",
        component: () => import("@/view/coupon_card"),
      },
      /* 门店账户 */
      // {
      //   path: "/store/order",
      //   name: "StoreOrder",
      //   component: () => import("@/view/store/Order"),
      // },
      // {
      //   path: "/store/money",
      //   name: "StoreMoney",
      //   component: () => import("@/view/store/Money"),
      // },

      /* 医生账号 */
      {
        path: "/doctor/myChatList",
        name: "DoctorChatList",
        component: () => import("@/view/doctor/MyChatList"),
      },
      {
        path: "/doctor/clinicalGuidelines",
        name: "ClinicalGuidelines",
        component: () => import("@/view/doctor/clinicalGuidelines"),
      },
      /* 柜门管理 */
      {
        path: "/openBox/boxList",
        name: "boxList",
        component: () => import("@/view/openBox/boxList"),
      },
      {
        path: "/openBox/openRecord",
        name: "OpenRecord",
        component: () => import("@/view/openBox/openRecord"),
      },
      /* 血压测量仪管理 */
      {
        path: "/instrument/list",
        name: "instrument",
        component: () => import("@/view/instrument/list"),
      },
      {
        path: "/instrument/order",
        name: "InstrumentOrder",
        component: () => import("@/view/instrument/order"),
      },

      /* 微信通知 */
      {
        path: "/sendService/sendTemplate",
        name: "SendTemplate",
        component: () => import("@/view/sendService/sendTemplate"),
      },
      {
        path: "/sendService/sendUser",
        name: "SendUser",
        component: () => import("@/view/sendService/sendUser"),
      },
      {
        path: "/sendService/sendRecord",
        name: "SendRecord",
        component: () => import("@/view/sendService/sendRecord"),
      }
    ],
  },

  // 登录页
  {
    path: "*",
    name: "Login",
    meta: {
      auth: true,
    },
    component: () => import("@/view/LoginPage"),
  },
  ],
  // mode: "history",
  mode: "hash",
};